import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { SharedModule } from '@app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeService } from './home.service';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatMenuModule } from "@angular/material/menu";
import { CreateOrEditKeywordDialogComponent } from './dialogs/create-edit-keyword-dialog/create-edit-keyword-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { DeleteKeywordConfirmationDialogComponent } from './dialogs/delete-keyword-confirmation-dialog/delete-keyword-confirmation-dialog.component';

const routes: Routes = [
  { path: '', component: HomeComponent }
];

@NgModule({
  declarations: [
    HomeComponent,
    CreateOrEditKeywordDialogComponent,
    DeleteKeywordConfirmationDialogComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    MatCheckboxModule,
    MatPaginatorModule,
    MatMenuModule,
    MatInputModule,
    ReactiveFormsModule
],
  providers: [
    HomeService
  ]
})
export class HomeModule { }
